import React, { useState } from 'react';
import { useUser } from '../hooks/useUser';
import '../css/CardMenu.css';
import '../css/ChangeUsername.css';

const ChangeUsername = ({ onClose }) => {
    const { user, changeUsername } = useUser();
    const [newUsername, setNewUsername] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');
        setError('');

        try {
            const result = await changeUsername(newUsername);
            setMessage(result.message);
            setNewUsername(''); // Clear the input
            // Close popup after successful change
            setTimeout(() => {
                onClose();
            }, 2000);
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const getLastChangeInfo = () => {
        if (!user?.lastNameChanged) return null;
        
        const lastChanged = new Date(user.lastNameChanged);
        const nextChangeAvailable = new Date(lastChanged.getTime() + 7 * 24 * 60 * 60 * 1000);
        const now = new Date();
        
        if (nextChangeAvailable > now) {
            const daysLeft = Math.ceil((nextChangeAvailable - now) / (24 * 60 * 60 * 1000));
            return `You can change your username again in ${daysLeft} day(s).`;
        }
        
        return 'You can change your username now.';
    };

    return (
        <div className="card-menu">
            <div className='card-menu-container'>
                <h1 className='title-events'>Change Username</h1>
                <button className="overlay-close" onClick={onClose}>X</button>
                
                <div className='card-menu-content'>
                    <div className='username-change-form'>
                        <p className="current-username">Current username: <strong>{user?.username}</strong></p>
                        {getLastChangeInfo() && <p className="info">{getLastChangeInfo()}</p>}
                        
                        <form onSubmit={handleSubmit} className="change-username-form">
                            <div className="form-group">
                                <label htmlFor="newUsername">New Username:</label>
                                <input
                                    type="text"
                                    id="newUsername"
                                    value={newUsername}
                                    onChange={(e) => setNewUsername(e.target.value)}
                                    placeholder="Enter new username..."
                                    minLength={3}
                                    maxLength={20}
                                    pattern="[a-zA-Z0-9]+"
                                    title="Username can only contain letters and numbers"
                                    required
                                    className="market-searchbar"
                                />
                            </div>
                            
                            <button 
                                type="submit" 
                                disabled={isLoading || !newUsername.trim()}
                                className="default-button big submit-button"
                            >
                                {isLoading ? <div className='loader-small'/> : 'Change Username'}
                            </button>
                        </form>

                        {message && (
                            <div className="success-message">
                                {message}
                            </div>
                        )}

                        {error && (
                            <div className="error-message">
                                {error}
                            </div>
                        )}

                        <div className="username-rules">
                            <h4>Username Rules:</h4>
                            <ul>
                                <li>Must be 3-20 characters long</li>
                                <li>Can only contain letters and numbers</li>
                                <li>Cannot contain profanity</li>
                                <li>Can only be changed once per week</li>
                                <li>Must be different from current username</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangeUsername;
